<template>
  <div v-if="!isSidney">
    <FeedbackMenu
      class="lg:inline-block"
      :class="[enableMobileMode ? 'hidden' : '', dark ? 'dark' : '']"
      position="bottom-right"
      :items="langItems"
    >
      <template #button>
        <slot :locale="locale">
          <button
            class="inline-flex w-full items-center justify-center rounded-md bg-transparent p-2 font-medium text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
          >
            <span class="uppercase" v-text="locale"></span>
            <NavigationChevronDown class="ml-2 h-4 w-4" />
          </button>
        </slot>
      </template>
    </FeedbackMenu>
    <div v-if="enableMobileMode" class="bg-white px-6 lg:hidden">
      <div
        class="flex w-full items-center justify-center border-b border-shade-900 py-6"
      >
        <NuxtLink
          v-for="l in locales"
          :key="l.code"
          :class="[
            ' uppercase ml-4 first:ml-0 text-mobile-lg lg:text-base',
            l.code === locale
              ? 'text-shade-900 underline underline-offset-4'
              : 'text-primary-400',
          ]"
          :to="switchLocalePath(l.code)"
        >
          {{ l.code }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from '#i18n'
import NavigationChevronDown from '~/assets/icon/navigation/Chevron/Down.svg'
const route = useRoute()
const path = ref(route.path)
watch(
  () => route.path,
  (newValue) => {
    path.value = newValue
  }
)
const isSidney = computed(() => {
  const splitPath = path.value.split('/')
  const firstParam = splitPath[1].toLowerCase()
  if (firstParam === 'sidney') {
    return true
  }
  if (splitPath.length < 3) {
    return false
  }
  const secondParam = splitPath[2].toLowerCase()
  if (secondParam === 'sidney') {
    return true
  }
  return false
})

const switchLocalePath = useSwitchLocalePath()

const props = defineProps({
  enableMobileMode: {
    type: Boolean,
    default: true,
  },
  dark: {
    type: Boolean,
    default: false,
  },
})

// Locales
const { locale, locales } = useI18n()

const getLocaleName = (code: string) => {
  const locale = locales.value.find((i) => i.code === code)
  return locale ? locale.name : code
}

// TODO : fix when i18n module is released for nuxt3
// https://github.com/nuxt-community/i18n-module/issues/1410

const langItems = computed<MenuElement[]>(() => {
  return locales.value.map((locale) => {
    return {
      label: getLocaleName(locale.code),
      href: switchLocalePath(locale.code),
    }
  })
})
</script>
